export default function HeaderLeft(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19" fill="none" {...props}>
            <g filter="url(#filter0_d_2420_2038)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.98139 14.0391C3.48275 12.1879 4.87102 8.85703 6.74304 8.72531C6.05088 12.0075 6.98826 14.903 8.83624 14.8418C11.3156 14.7596 12.321 10.526 9.21024 8.35103C8.86429 8.10914 8.51632 7.94304 8.17128 7.84424C8.67958 6.37958 9.49071 5.04373 10.5847 4.31881C13.5436 2.35816 15.7181 2.47472 16.7652 2.53086C16.8387 2.5348 16.9067 2.53844 16.9689 2.54104C17.9184 2.58077 18.817 0.201699 16.918 0.122251C15.019 0.0428019 10.5871 0.972736 8.05188 5.32819C7.59012 6.12148 7.24034 6.94411 6.99204 7.75859C4.72572 8.07085 2.86328 11.0672 2.98139 14.0391ZM7.92461 8.92051C10.3908 10.2479 10.7306 14.8113 8.76657 14.1967C7.60429 13.833 7.35267 11.3719 7.92461 8.92051Z"
                    fill="url(#paint0_linear_2420_2038)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_2420_2038"
                    x="0.976562"
                    y="0.117676"
                    width="19.0586"
                    height="18.7251"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2420_2038" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2420_2038" result="shape" />
                </filter>
                <linearGradient id="paint0_linear_2420_2038" x1="24.1712" y1="3.89749" x2="0.253875" y2="16.0315" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFF730" />
                    <stop offset="0.195312" stopColor="#FFC700" />
                    <stop offset="0.60249" stopColor="#FFE872" />
                    <stop offset="0.867876" stopColor="#FF8A00" />
                    <stop offset="1" stopColor="#FED05A" />
                </linearGradient>
            </defs>
        </svg>
    );
}
